import './Loader.css';
import beautiLogo from '../assets/images/logo.png';
const Loader = () => (
  <div className="theme_loader_fix" role="status" aria-live="polite" aria-label="Loading">
    <span className="visually-hidden">Loading...</span>
    <div className="beauti-loader">
      <span className="beauti-loader-ring beauti-loader-ring-outer" aria-hidden="true" />
      <span className="beauti-loader-ring beauti-loader-ring-inner" aria-hidden="true" />
      <span className="beauti-loader-ring beauti-loader-ring-top" aria-hidden="true" />
      <div className="beauti-loader-logo"><img src={beautiLogo} alt="Beauti" /></div>
    </div>
  </div>
);
export default Loader;
